<template>
  <div>
    <div class="pa-0 ma-0" >
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
            <div class="fonts-white container pl-0 pr-1" >
              <div class="overlay-grey-web">
                  <ChatApp 
                    v-if="this.authToken"
                    :token="this.authToken"
                  />
              </div>
            </div>
        </div>
        <v-row :style="(this.isMobileXs || this.isMobilePlayer3) ? 'padding-top:120px!important':'padding-top:123px!important'"></v-row>
      </div>
    </div>
</div>
</template>

<script>
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
import ChatApp from '@/components/chat/ChatApp.vue'


export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Messenger',

  components: {
        ChatApp
  },
  data: () => ({
    navbar: false,
    user: null,
    authToken: null,


  }),
  mounted() {   
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function() {
          this.user = this.$store.getters.getUserData;
          this.authToken = this.user?.token || null;
      },    
  },
  computed: {
    isfullScreen(){
      if(this.isMobile && this.isMobileXs){
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
          return this.$store.getters.getUserData != null
      },
    isDesktop() {
        if (!this.navbar){
          return true;
        } else {
          return false;
        }
      },
    getGextPanel() {
      if(this.navbar){
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },

  },  
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;    
      this.authToken = this.user.token;

      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }

    }
  }, 
  methods: {

    checkScreenSize() {
      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link){
      if (link === 'TryMuzE'){
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse'){
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

@use './css/styles.scss';

@keyframes blink {
  0% {
    opacity: 1;
  }
  40% {
    opacity: 1;
  }
  60% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}

.blink {
      -webkit-animation: blink 1.5s infinite both;
            animation: blink 1.5s infinite both;
}

:deep(.v-btn:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true])>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-btn[aria-haspopup=menu][aria-expanded=true]:hover)>.v-btn__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item:hover)>.v-list-item__overlay {
  --v-hover-opacity: 0;
  opacity: 0;
}

:deep(.v-list-item__append){
  display: inline-block;
}

.sign-up-text-policy {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  color: white !important;
}

#videoContainer {
  position: relative;
  box-sizing: border-box;
  max-height: 1000px;
  transition: height 0.10s linear;
}

#videoContent {
  position: sticky;
  top: 0;
  max-height: 1000px;
  transition: height 0.10s linear;
}

#bkgrdVideoOverlay {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 1000px;
  object-fit: cover; 
  background-color: #0000008f; 
  z-index: 5;
  transition: height 0.10s linear;
}
#bkgrdVideoFunc {
  position: absolute;
  top:0;
  left:0;
  width: 100%;
  max-height: 1000px;
  object-fit: cover; 
  background-color: #00000000; 
  z-index: 6;
  transition: height 0.10s linear;
}

#bkgrdVideo {
  width: 100%;
  max-height: 1000px;
  object-fit: cover; 
  z-index:1;
  transition: height 0.10s linear;
}
.overall {
  background-color: black !important;
  object-fit: cover; 
  height: 100%; 
  display: block;
}
.body-overall {
  background-color: black !important;
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  z-index: 3;
}
.nomenu-btn-page {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-page.active,
.nomenu-btn-page:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-page::before {
  content: "";
  position: absolute;
  left: 4px;
  top: 30px;
  width: 92%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: white; /* Color of the underline */
  opacity: 1; /* Initially hide the underline */
}

.nomenu-btn-page.active::before,
.nomenu-btn-page:hover::before {
  opacity: 0.3; /* Show the underline when hovering */
}

.nomenu-btn-link {
  color: white;
  font-family: "Darker Grotesque", sans-serif;
  font-weight: 500;
  font-size: 20px;
  transition: none !important;
  background-color: transparent !important;
  margin-left: 10px;
  padding-left: 2px;
  margin-right: 10px;
  padding-right: 2px;
}

.nomenu-btn-link.active,
.nomenu-btn-link:hover {
  color: white;
  background-color: transparent !important;
  transition: none;
}

.nomenu-btn-link::before {
  content: "";
  position: absolute;
  left: 0px;
  top: 30px;
  width: 100%; /* Spread the line over the text and icon */
  height: 1px; /* Line thickness */
  background-color: white; /* Color of the underline */
  opacity: 0; /* Initially hide the underline */
}

.nomenu-btn-link.active::before,
.nomenu-btn-link:hover::before {
  opacity: 1; /* Show the underline when hovering */
}

.typing-container {
  display: flex;
  
  align-items: center; /* Vertically center */

}

.cursor {
  display: inline-block;
  width: 16px;
  height: 30px;
  background-color: white;
  margin-left: 2px;
  animation: blink 0.6s linear infinite alternate;
}

#feature-text {
  margin-left: 8px;
  color: white;
}

.span-fonts-on {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  border: 1px solid white;
  border-radius: 16px;
  background-color: black;
  border-width: 1px;
}

.span-fonts-off {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  border: black;
  border-radius: 16px;
  background-color: #e2474b;
  border-width: 2px;
  filter: grayscale(15%);
}

.password-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 320px !important;
  border: 1px solid #121212;
  border-radius: 10px;
  color: white !important;
  background-color: #121212 !important;
}

.email-font {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 18px !important;
  min-width: 320px !important;
  border: 1px solid #121212;
  border-radius: 10px;
  color: white !important;
  background-color: #121212 !important;
}

</style>
